[
  {
    "alpha2": "DZ",
    "alpha3": "DZA",
    "code": "012",
    "name": "Algeria",
    "emoji": "🇩🇿",
    "unicode": "U+1F1E9 U+1F1FF",
    "dialCode": "+213",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg"
  },
  {
    "alpha2": "AO",
    "alpha3": "AGO",
    "code": "024",
    "name": "Angola",
    "emoji": "🇦🇴",
    "unicode": "U+1F1E6 U+1F1F4",
    "dialCode": "+244",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg"
  },
  {
    "alpha2": "BJ",
    "alpha3": "BEN",
    "code": "204",
    "name": "Benin",
    "emoji": "🇧🇯",
    "unicode": "U+1F1E7 U+1F1EF",
    "dialCode": "+229",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg"
  },
  {
    "alpha2": "BW",
    "alpha3": "BWA",
    "code": "072",
    "name": "Botswana",
    "emoji": "🇧🇼",
    "unicode": "U+1F1E7 U+1F1FC",
    "dialCode": "+267",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg"
  },
  {
    "alpha2": "BF",
    "alpha3": "BFA",
    "code": "854",
    "name": "Burkina Faso",
    "emoji": "🇧🇫",
    "unicode": "U+1F1E7 U+1F1EB",
    "dialCode": "+226",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg"
  },
  {
    "alpha2": "BI",
    "alpha3": "BDI",
    "code": "108",
    "name": "Burundi",
    "emoji": "🇧🇮",
    "unicode": "U+1F1E7 U+1F1EE",
    "dialCode": "+257",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg"
  },
  {
    "alpha2": "CM",
    "alpha3": "CMR",
    "code": "120",
    "name": "Cameroon",
    "emoji": "🇨🇲",
    "unicode": "U+1F1E8 U+1F1F2",
    "dialCode": "+237",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg"
  },
  {
    "alpha2": "CV",
    "alpha3": "CPV",
    "code": "132",
    "name": "Cape Verde",
    "emoji": "🇨🇻",
    "unicode": "U+1F1E8 U+1F1FB",
    "dialCode": "+238",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg"
  },
  {
    "alpha2": "CF",
    "alpha3": "CAF",
    "code": "140",
    "name": "Central African Republic",
    "emoji": "🇨🇫",
    "unicode": "U+1F1E8 U+1F1EB",
    "dialCode": "+236",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg"
  },
  {
    "alpha2": "TD",
    "alpha3": "TCD",
    "code": "148",
    "name": "Chad",
    "emoji": "🇹🇩",
    "unicode": "U+1F1F9 U+1F1E9",
    "dialCode": "+235",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg"
  },
  {
    "alpha2": "KM",
    "alpha3": "COM",
    "code": "174",
    "name": "Comoros",
    "emoji": "🇰🇲",
    "unicode": "U+1F1F0 U+1F1F2",
    "dialCode": "+269",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg"
  },
  {
    "alpha2": "CG",
    "alpha3": "COG",
    "code": "178",
    "name": "Congo",
    "emoji": "🇨🇬",
    "unicode": "U+1F1E8 U+1F1EC",
    "dialCode": "+242",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg"
  },
  {
    "alpha2": "CD",
    "alpha3": "COD",
    "code": "180",
    "name": "Congo, the Democratic Republic of the",
    "emoji": "🇨🇩",
    "unicode": "U+1F1E8 U+1F1E9",
    "dialCode": "+243",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg"
  },
  {
    "alpha2": "CI",
    "alpha3": "CIV",
    "code": "384",
    "name": "Cote D'Ivoire",
    "emoji": "🇨🇮",
    "unicode": "U+1F1E8 U+1F1EE",
    "dialCode": "+225",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg"
  },
  {
    "alpha2": "DJ",
    "alpha3": "DJI",
    "code": "262",
    "name": "Djibouti",
    "emoji": "🇩🇯",
    "unicode": "U+1F1E9 U+1F1EF",
    "dialCode": "+253",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg"
  },
  {
    "alpha2": "EG",
    "alpha3": "EGY",
    "code": "818",
    "name": "Egypt",
    "emoji": "🇪🇬",
    "unicode": "U+1F1EA U+1F1EC",
    "dialCode": "+20",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg"
  },
  {
    "alpha2": "GQ",
    "alpha3": "GNQ",
    "code": "226",
    "name": "Equatorial Guinea",
    "emoji": "🇬🇶",
    "unicode": "U+1F1EC U+1F1F6",
    "dialCode": "+240",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg"
  },
  {
    "alpha2": "ER",
    "alpha3": "ERI",
    "code": "232",
    "name": "Eritrea",
    "emoji": "🇪🇷",
    "unicode": "U+1F1EA U+1F1F7",
    "dialCode": "+291",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg"
  },
  {
    "alpha2": "ET",
    "alpha3": "ETH",
    "code": "231",
    "name": "Ethiopia",
    "emoji": "🇪🇹",
    "unicode": "U+1F1EA U+1F1F9",
    "dialCode": "+251",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg"
  },
  {
    "alpha2": "GA",
    "alpha3": "GAB",
    "code": "266",
    "name": "Gabon",
    "emoji": "🇬🇦",
    "unicode": "U+1F1EC U+1F1E6",
    "dialCode": "+241",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg"
  },
  {
    "alpha2": "GM",
    "alpha3": "GMB",
    "code": "270",
    "name": "Gambia",
    "emoji": "🇬🇲",
    "unicode": "U+1F1EC U+1F1F2",
    "dialCode": "+220",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg"
  },
  {
    "alpha2": "GH",
    "alpha3": "GHA",
    "code": "288",
    "name": "Ghana",
    "emoji": "🇬🇭",
    "unicode": "U+1F1EC U+1F1ED",
    "dialCode": "+233",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg"
  },
  {
    "alpha2": "GN",
    "alpha3": "GIN",
    "code": "324",
    "name": "Guinea",
    "emoji": "🇬🇳",
    "unicode": "U+1F1EC U+1F1F3",
    "dialCode": "+224",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg"
  },
  {
    "alpha2": "GW",
    "alpha3": "GNB",
    "code": "624",
    "name": "Guinea-Bissau",
    "emoji": "🇬🇼",
    "unicode": "U+1F1EC U+1F1FC",
    "dialCode": "+245",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg"
  },
  {
    "alpha2": "KE",
    "alpha3": "KEN",
    "code": "404",
    "name": "Kenya",
    "emoji": "🇰🇪",
    "unicode": "U+1F1F0 U+1F1EA",
    "dialCode": "+254",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg"
  },
  {
    "alpha2": "LS",
    "alpha3": "LSO",
    "code": "426",
    "name": "Lesotho",
    "emoji": "🇱🇸",
    "unicode": "U+1F1F1 U+1F1F8",
    "dialCode": "+266",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg"
  },
  {
    "alpha2": "LR",
    "alpha3": "LBR",
    "code": "430",
    "name": "Liberia",
    "emoji": "🇱🇷",
    "unicode": "U+1F1F1 U+1F1F7",
    "dialCode": "+231",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg"
  },
  {
    "alpha2": "LY",
    "alpha3": "LBY",
    "code": "434",
    "name": "Libyan Arab Jamahiriya",
    "emoji": "🇱🇾",
    "unicode": "U+1F1F1 U+1F1FE",
    "dialCode": "+218",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg"
  },
  {
    "alpha2": "MG",
    "alpha3": "MDG",
    "code": "450",
    "name": "Madagascar",
    "emoji": "🇲🇬",
    "unicode": "U+1F1F2 U+1F1EC",
    "dialCode": "+261",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg"
  },
  {
    "alpha2": "MW",
    "alpha3": "MWI",
    "code": "454",
    "name": "Malawi",
    "emoji": "🇲🇼",
    "unicode": "U+1F1F2 U+1F1FC",
    "dialCode": "+265",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg"
  },
  {
    "alpha2": "ML",
    "alpha3": "MLI",
    "code": "466",
    "name": "Mali",
    "emoji": "🇲🇱",
    "unicode": "U+1F1F2 U+1F1F1",
    "dialCode": "+223",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg"
  },
  {
    "alpha2": "MR",
    "alpha3": "MRT",
    "code": "478",
    "name": "Mauritania",
    "emoji": "🇲🇷",
    "unicode": "U+1F1F2 U+1F1F7",
    "dialCode": "+222",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg"
  },
  {
    "alpha2": "MU",
    "alpha3": "MUS",
    "code": "480",
    "name": "Mauritius",
    "emoji": "🇲🇺",
    "unicode": "U+1F1F2 U+1F1FA",
    "dialCode": "+230",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg"
  },
  {
    "alpha2": "YT",
    "alpha3": "MYT",
    "code": "175",
    "name": "Mayotte",
    "emoji": "🇾🇹",
    "unicode": "U+1F1FE U+1F1F9",
    "dialCode": "+262",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg"
  },
  {
    "alpha2": "MA",
    "alpha3": "MAR",
    "code": "504",
    "name": "Morocco",
    "emoji": "🇲🇦",
    "unicode": "U+1F1F2 U+1F1E6",
    "dialCode": "+212",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg"
  },
  {
    "alpha2": "MZ",
    "alpha3": "MOZ",
    "code": "508",
    "name": "Mozambique",
    "emoji": "🇲🇿",
    "unicode": "U+1F1F2 U+1F1FF",
    "dialCode": "+258",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg"
  },
  {
    "alpha2": "NA",
    "alpha3": "NAM",
    "code": "516",
    "name": "Namibia",
    "emoji": "🇳🇦",
    "unicode": "U+1F1F3 U+1F1E6",
    "dialCode": "+264",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg"
  },
  {
    "alpha2": "NE",
    "alpha3": "NER",
    "code": "562",
    "name": "Niger",
    "emoji": "🇳🇪",
    "unicode": "U+1F1F3 U+1F1EA",
    "dialCode": "+227",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg"
  },
  {
    "alpha2": "NG",
    "alpha3": "NGA",
    "code": "566",
    "name": "Nigeria",
    "emoji": "🇳🇬",
    "unicode": "U+1F1F3 U+1F1EC",
    "dialCode": "+234",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg"
  },
  {
    "alpha2": "RE",
    "alpha3": "REU",
    "code": "638",
    "name": "Reunion",
    "emoji": "🇷🇪",
    "unicode": "U+1F1F7 U+1F1EA",
    "dialCode": "+262",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg"
  },
  {
    "alpha2": "RW",
    "alpha3": "RWA",
    "code": "646",
    "name": "Rwanda",
    "emoji": "🇷🇼",
    "unicode": "U+1F1F7 U+1F1FC",
    "dialCode": "+250",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg"
  },
  {
    "alpha2": "SH",
    "alpha3": "SHN",
    "code": "654",
    "name": "Saint Helena",
    "emoji": "🇸🇭",
    "unicode": "U+1F1F8 U+1F1ED",
    "dialCode": "+290",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg"
  },
  {
    "alpha2": "ST",
    "alpha3": "STP",
    "code": "678",
    "name": "Sao Tome and Principe",
    "emoji": "🇸🇹",
    "unicode": "U+1F1F8 U+1F1F9",
    "dialCode": "+239",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg"
  },
  {
    "alpha2": "SN",
    "alpha3": "SEN",
    "code": "686",
    "name": "Senegal",
    "emoji": "🇸🇳",
    "unicode": "U+1F1F8 U+1F1F3",
    "dialCode": "+221",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg"
  },
  {
    "alpha2": "SC",
    "alpha3": "SYC",
    "code": "690",
    "name": "Seychelles",
    "emoji": "🇸🇨",
    "unicode": "U+1F1F8 U+1F1E8",
    "dialCode": "+248",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg"
  },
  {
    "alpha2": "SL",
    "alpha3": "SLE",
    "code": "694",
    "name": "Sierra Leone",
    "emoji": "🇸🇱",
    "unicode": "U+1F1F8 U+1F1F1",
    "dialCode": "+232",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg"
  },
  {
    "alpha2": "SO",
    "alpha3": "SOM",
    "code": "706",
    "name": "Somalia",
    "emoji": "🇸🇴",
    "unicode": "U+1F1F8 U+1F1F4",
    "dialCode": "+252",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg"
  },
  {
    "alpha2": "ZA",
    "alpha3": "ZAF",
    "code": "710",
    "name": "South Africa",
    "emoji": "🇿🇦",
    "unicode": "U+1F1FF U+1F1E6",
    "dialCode": "+27",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg"
  },
  {
    "alpha2": "SS",
    "alpha3": "SSD",
    "code": "728",
    "name": "South Sudan",
    "emoji": "🇸🇸",
    "unicode": "U+1F1F8 U+1F1F8",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg"
  },
  {
    "alpha2": "SD",
    "alpha3": "SDN",
    "code": "729",
    "name": "Sudan",
    "emoji": "🇸🇩",
    "unicode": "U+1F1F8 U+1F1E9",
    "dialCode": "+249",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg"
  },
  {
    "alpha2": "SZ",
    "alpha3": "SWZ",
    "code": "748",
    "name": "Swaziland",
    "emoji": "🇸🇿",
    "unicode": "U+1F1F8 U+1F1FF",
    "dialCode": "+268",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg"
  },
  {
    "alpha2": "TZ",
    "alpha3": "TZA",
    "code": "834",
    "name": "Tanzania, United Republic of",
    "emoji": "🇹🇿",
    "unicode": "U+1F1F9 U+1F1FF",
    "dialCode": "+255",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg"
  },
  {
    "alpha2": "TG",
    "alpha3": "TGO",
    "code": "768",
    "name": "Togo",
    "emoji": "🇹🇬",
    "unicode": "U+1F1F9 U+1F1EC",
    "dialCode": "+228",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg"
  },
  {
    "alpha2": "TN",
    "alpha3": "TUN",
    "code": "788",
    "name": "Tunisia",
    "emoji": "🇹🇳",
    "unicode": "U+1F1F9 U+1F1F3",
    "dialCode": "+216",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg"
  },
  {
    "alpha2": "UG",
    "alpha3": "UGA",
    "code": "800",
    "name": "Uganda",
    "emoji": "🇺🇬",
    "unicode": "U+1F1FA U+1F1EC",
    "dialCode": "+256",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg"
  },
  {
    "alpha2": "EH",
    "alpha3": "ESH",
    "code": "732",
    "name": "Western Sahara",
    "emoji": "🇪🇭",
    "unicode": "U+1F1EA U+1F1ED",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EH.svg"
  },
  {
    "alpha2": "ZM",
    "alpha3": "ZMB",
    "code": "894",
    "name": "Zambia",
    "emoji": "🇿🇲",
    "unicode": "U+1F1FF U+1F1F2",
    "dialCode": "+260",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg"
  },
  {
    "alpha2": "ZW",
    "alpha3": "ZWE",
    "code": "716",
    "name": "Zimbabwe",
    "emoji": "🇿🇼",
    "unicode": "U+1F1FF U+1F1FC",
    "dialCode": "+263",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg"
  },
  {
    "alpha2": "AF",
    "alpha3": "AFG",
    "code": "004",
    "name": "Afghanistan",
    "emoji": "🇦🇫",
    "unicode": "U+1F1E6 U+1F1EB",
    "dialCode": "+93",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg"
  },
  {
    "alpha2": "AM",
    "alpha3": "ARM",
    "code": "051",
    "name": "Armenia",
    "emoji": "🇦🇲",
    "unicode": "U+1F1E6 U+1F1F2",
    "dialCode": "+374",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg"
  },
  {
    "alpha2": "AZ",
    "alpha3": "AZE",
    "code": "031",
    "name": "Azerbaijan",
    "emoji": "🇦🇿",
    "unicode": "U+1F1E6 U+1F1FF",
    "dialCode": "+994",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg"
  },
  {
    "alpha2": "BH",
    "alpha3": "BHR",
    "code": "048",
    "name": "Bahrain",
    "emoji": "🇧🇭",
    "unicode": "U+1F1E7 U+1F1ED",
    "dialCode": "+973",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg"
  },
  {
    "alpha2": "BD",
    "alpha3": "BGD",
    "code": "050",
    "name": "Bangladesh",
    "emoji": "🇧🇩",
    "unicode": "U+1F1E7 U+1F1E9",
    "dialCode": "+880",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg"
  },
  {
    "alpha2": "BT",
    "alpha3": "BTN",
    "code": "064",
    "name": "Bhutan",
    "emoji": "🇧🇹",
    "unicode": "U+1F1E7 U+1F1F9",
    "dialCode": "+975",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg"
  },
  {
    "alpha2": "IO",
    "alpha3": "IOT",
    "code": "086",
    "name": "British Indian Ocean Territory",
    "emoji": "🇮🇴",
    "unicode": "U+1F1EE U+1F1F4",
    "dialCode": "+246",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg"
  },
  {
    "alpha2": "BN",
    "alpha3": "BRN",
    "code": "096",
    "name": "Brunei Darussalam",
    "emoji": "🇧🇳",
    "unicode": "U+1F1E7 U+1F1F3",
    "dialCode": "+673",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg"
  },
  {
    "alpha2": "KH",
    "alpha3": "KHM",
    "code": "116",
    "name": "Cambodia",
    "emoji": "🇰🇭",
    "unicode": "U+1F1F0 U+1F1ED",
    "dialCode": "+855",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg"
  },
  {
    "alpha2": "CN",
    "alpha3": "CHN",
    "code": "156",
    "name": "China",
    "emoji": "🇨🇳",
    "unicode": "U+1F1E8 U+1F1F3",
    "dialCode": "+86",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg"
  },
  {
    "alpha2": "CX",
    "alpha3": "CXR",
    "code": "162",
    "name": "Christmas Island",
    "emoji": "🇨🇽",
    "unicode": "U+1F1E8 U+1F1FD",
    "dialCode": "+61",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg"
  },
  {
    "alpha2": "CC",
    "alpha3": "CCK",
    "code": "166",
    "name": "Cocos (Keeling) Islands",
    "emoji": "🇨🇨",
    "unicode": "U+1F1E8 U+1F1E8",
    "dialCode": "+61",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg"
  },
  {
    "alpha2": "GE",
    "alpha3": "GEO",
    "code": "268",
    "name": "Georgia",
    "emoji": "🇬🇪",
    "unicode": "U+1F1EC U+1F1EA",
    "dialCode": "+995",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg"
  },
  {
    "alpha2": "HK",
    "alpha3": "HKG",
    "code": "344",
    "name": "Hong Kong",
    "emoji": "🇭🇰",
    "unicode": "U+1F1ED U+1F1F0",
    "dialCode": "+852",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg"
  },
  {
    "alpha2": "IN",
    "alpha3": "IND",
    "code": "356",
    "name": "India",
    "emoji": "🇮🇳",
    "unicode": "U+1F1EE U+1F1F3",
    "dialCode": "+91",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg"
  },
  {
    "alpha2": "ID",
    "alpha3": "IDN",
    "code": "360",
    "name": "Indonesia",
    "emoji": "🇮🇩",
    "unicode": "U+1F1EE U+1F1E9",
    "dialCode": "+62",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg"
  },
  {
    "alpha2": "IR",
    "alpha3": "IRN",
    "code": "364",
    "name": "Iran, Islamic Republic of",
    "emoji": "🇮🇷",
    "unicode": "U+1F1EE U+1F1F7",
    "dialCode": "+98",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg"
  },
  {
    "alpha2": "IQ",
    "alpha3": "IRQ",
    "code": "368",
    "name": "Iraq",
    "emoji": "🇮🇶",
    "unicode": "U+1F1EE U+1F1F6",
    "dialCode": "+964",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg"
  },
  {
    "alpha2": "JP",
    "alpha3": "JPN",
    "code": "392",
    "name": "Japan",
    "emoji": "🇯🇵",
    "unicode": "U+1F1EF U+1F1F5",
    "dialCode": "+81",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg"
  },
  {
    "alpha2": "JO",
    "alpha3": "JOR",
    "code": "400",
    "name": "Jordan",
    "emoji": "🇯🇴",
    "unicode": "U+1F1EF U+1F1F4",
    "dialCode": "+962",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg"
  },
  {
    "alpha2": "KZ",
    "alpha3": "KAZ",
    "code": "398",
    "name": "Kazakhstan",
    "emoji": "🇰🇿",
    "unicode": "U+1F1F0 U+1F1FF",
    "dialCode": "+7 7",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg"
  },
  {
    "alpha2": "KP",
    "alpha3": "PRK",
    "code": "408",
    "name": "North Korea",
    "emoji": "🇰🇵",
    "unicode": "U+1F1F0 U+1F1F5",
    "dialCode": "+850",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg"
  },
  {
    "alpha2": "KR",
    "alpha3": "KOR",
    "code": "410",
    "name": "South Korea",
    "emoji": "🇰🇷",
    "unicode": "U+1F1F0 U+1F1F7",
    "dialCode": "+82",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg"
  },
  {
    "alpha2": "KW",
    "alpha3": "KWT",
    "code": "414",
    "name": "Kuwait",
    "emoji": "🇰🇼",
    "unicode": "U+1F1F0 U+1F1FC",
    "dialCode": "+965",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg"
  },
  {
    "alpha2": "KG",
    "alpha3": "KGZ",
    "code": "417",
    "name": "Kyrgyzstan",
    "emoji": "🇰🇬",
    "unicode": "U+1F1F0 U+1F1EC",
    "dialCode": "+996",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg"
  },
  {
    "alpha2": "LA",
    "alpha3": "LAO",
    "code": "418",
    "name": "Laos",
    "emoji": "🇱🇦",
    "unicode": "U+1F1F1 U+1F1E6",
    "dialCode": "+856",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg"
  },
  {
    "alpha2": "LB",
    "alpha3": "LBN",
    "code": "422",
    "name": "Lebanon",
    "emoji": "🇱🇧",
    "unicode": "U+1F1F1 U+1F1E7",
    "dialCode": "+961",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg"
  },
  {
    "alpha2": "MO",
    "alpha3": "MAC",
    "code": "446",
    "name": "Macao",
    "emoji": "🇲🇴",
    "unicode": "U+1F1F2 U+1F1F4",
    "dialCode": "+853",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg"
  },
  {
    "alpha2": "MY",
    "alpha3": "MYS",
    "code": "458",
    "name": "Malaysia",
    "emoji": "🇲🇾",
    "unicode": "U+1F1F2 U+1F1FE",
    "dialCode": "+60",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg"
  },
  {
    "alpha2": "MV",
    "alpha3": "MDV",
    "code": "462",
    "name": "Maldives",
    "emoji": "🇲🇻",
    "unicode": "U+1F1F2 U+1F1FB",
    "dialCode": "+960",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg"
  },
  {
    "alpha2": "MN",
    "alpha3": "MNG",
    "code": "496",
    "name": "Mongolia",
    "emoji": "🇲🇳",
    "unicode": "U+1F1F2 U+1F1F3",
    "dialCode": "+976",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg"
  },
  {
    "alpha2": "MM",
    "alpha3": "MMR",
    "code": "104",
    "name": "Myanmar",
    "emoji": "🇲🇲",
    "unicode": "U+1F1F2 U+1F1F2",
    "dialCode": "+95",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg"
  },
  {
    "alpha2": "NP",
    "alpha3": "NPL",
    "code": "524",
    "name": "Nepal",
    "emoji": "🇳🇵",
    "unicode": "U+1F1F3 U+1F1F5",
    "dialCode": "+977",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg"
  },
  {
    "alpha2": "OM",
    "alpha3": "OMN",
    "code": "512",
    "name": "Oman",
    "emoji": "🇴🇲",
    "unicode": "U+1F1F4 U+1F1F2",
    "dialCode": "+968",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg"
  },
  {
    "alpha2": "PK",
    "alpha3": "PAK",
    "code": "586",
    "name": "Pakistan",
    "emoji": "🇵🇰",
    "unicode": "U+1F1F5 U+1F1F0",
    "dialCode": "+92",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg"
  },
  {
    "alpha2": "PS",
    "alpha3": "PSE",
    "code": "275",
    "name": "Palestinian Territory, Occupied",
    "emoji": "🇵🇸",
    "unicode": "U+1F1F5 U+1F1F8",
    "dialCode": "+970",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg"
  },
  {
    "alpha2": "PH",
    "alpha3": "PHL",
    "code": "608",
    "name": "Philippines",
    "emoji": "🇵🇭",
    "unicode": "U+1F1F5 U+1F1ED",
    "dialCode": "+63",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg"
  },
  {
    "alpha2": "QA",
    "alpha3": "QAT",
    "code": "634",
    "name": "Qatar",
    "emoji": "🇶🇦",
    "unicode": "U+1F1F6 U+1F1E6",
    "dialCode": "+974",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg"
  },
  {
    "alpha2": "SA",
    "alpha3": "SAU",
    "code": "682",
    "name": "Saudi Arabia",
    "emoji": "🇸🇦",
    "unicode": "U+1F1F8 U+1F1E6",
    "dialCode": "+966",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg"
  },
  {
    "alpha2": "SG",
    "alpha3": "SGP",
    "code": "702",
    "name": "Singapore",
    "emoji": "🇸🇬",
    "unicode": "U+1F1F8 U+1F1EC",
    "dialCode": "+65",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg"
  },
  {
    "alpha2": "LK",
    "alpha3": "LKA",
    "code": "144",
    "name": "Sri Lanka",
    "emoji": "🇱🇰",
    "unicode": "U+1F1F1 U+1F1F0",
    "dialCode": "+94",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg"
  },
  {
    "alpha2": "SY",
    "alpha3": "SYR",
    "code": "760",
    "name": "Syrian Arab Republic",
    "emoji": "🇸🇾",
    "unicode": "U+1F1F8 U+1F1FE",
    "dialCode": "+963",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg"
  },
  {
    "alpha2": "TW",
    "alpha3": "TWN",
    "code": "158",
    "name": "Taiwan",
    "emoji": "🇹🇼",
    "unicode": "U+1F1F9 U+1F1FC",
    "dialCode": "+886",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg"
  },
  {
    "alpha2": "TJ",
    "alpha3": "TJK",
    "code": "762",
    "name": "Tajikistan",
    "emoji": "🇹🇯",
    "unicode": "U+1F1F9 U+1F1EF",
    "dialCode": "+992",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg"
  },
  {
    "alpha2": "TH",
    "alpha3": "THA",
    "code": "764",
    "name": "Thailand",
    "emoji": "🇹🇭",
    "unicode": "U+1F1F9 U+1F1ED",
    "dialCode": "+66",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg"
  },
  {
    "alpha2": "TM",
    "alpha3": "TKM",
    "code": "795",
    "name": "Turkmenistan",
    "emoji": "🇹🇲",
    "unicode": "U+1F1F9 U+1F1F2",
    "dialCode": "+993",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg"
  },
  {
    "alpha2": "AE",
    "alpha3": "ARE",
    "code": "784",
    "name": "United Arab Emirates",
    "emoji": "🇦🇪",
    "unicode": "U+1F1E6 U+1F1EA",
    "dialCode": "+971",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg"
  },
  {
    "alpha2": "UZ",
    "alpha3": "UZB",
    "code": "860",
    "name": "Uzbekistan",
    "emoji": "🇺🇿",
    "unicode": "U+1F1FA U+1F1FF",
    "dialCode": "+998",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg"
  },
  {
    "alpha2": "VN",
    "alpha3": "VNM",
    "code": "704",
    "name": "Viet Nam",
    "emoji": "🇻🇳",
    "unicode": "U+1F1FB U+1F1F3",
    "dialCode": "+84",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg"
  },
  {
    "alpha2": "YE",
    "alpha3": "YEM",
    "code": "887",
    "name": "Yemen",
    "emoji": "🇾🇪",
    "unicode": "U+1F1FE U+1F1EA",
    "dialCode": "+967",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg"
  },
  {
    "alpha2": "AX",
    "alpha3": "ALA",
    "code": "248",
    "name": "Åland Islands",
    "emoji": "🇦🇽",
    "unicode": "U+1F1E6 U+1F1FD",
    "dialCode": "",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg"
  },
  {
    "alpha2": "AL",
    "alpha3": "ALB",
    "code": "008",
    "name": "Albania",
    "emoji": "🇦🇱",
    "unicode": "U+1F1E6 U+1F1F1",
    "dialCode": "+355",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg"
  },
  {
    "alpha2": "AD",
    "alpha3": "AND",
    "code": "020",
    "name": "Andorra",
    "emoji": "🇦🇩",
    "unicode": "U+1F1E6 U+1F1E9",
    "dialCode": "+376",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg"
  },
  {
    "alpha2": "AT",
    "alpha3": "AUT",
    "code": "040",
    "name": "Austria",
    "emoji": "🇦🇹",
    "unicode": "U+1F1E6 U+1F1F9",
    "dialCode": "+43",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg"
  },
  {
    "alpha2": "BY",
    "alpha3": "BLR",
    "code": "112",
    "name": "Belarus",
    "emoji": "🇧🇾",
    "unicode": "U+1F1E7 U+1F1FE",
    "dialCode": "+375",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg"
  },
  {
    "alpha2": "BE",
    "alpha3": "BEL",
    "code": "056",
    "name": "Belgium",
    "emoji": "🇧🇪",
    "unicode": "U+1F1E7 U+1F1EA",
    "dialCode": "+32",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg"
  },
  {
    "alpha2": "BA",
    "alpha3": "BIH",
    "code": "070",
    "name": "Bosnia and Herzegovina",
    "emoji": "🇧🇦",
    "unicode": "U+1F1E7 U+1F1E6",
    "dialCode": "+387",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg"
  },
  {
    "alpha2": "BG",
    "alpha3": "BGR",
    "code": "100",
    "name": "Bulgaria",
    "emoji": "🇧🇬",
    "unicode": "U+1F1E7 U+1F1EC",
    "dialCode": "+359",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg"
  },
  {
    "alpha2": "HR",
    "alpha3": "HRV",
    "code": "191",
    "name": "Croatia",
    "emoji": "🇭🇷",
    "unicode": "U+1F1ED U+1F1F7",
    "dialCode": "+385",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg"
  },
  {
    "alpha2": "CY",
    "alpha3": "CYP",
    "code": "196",
    "name": "Cyprus",
    "emoji": "🇨🇾",
    "unicode": "U+1F1E8 U+1F1FE",
    "dialCode": "+537",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg"
  },
  {
    "alpha2": "CZ",
    "alpha3": "CZE",
    "code": "203",
    "name": "Czech Republic",
    "emoji": "🇨🇿",
    "unicode": "U+1F1E8 U+1F1FF",
    "dialCode": "+420",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg"
  },
  {
    "alpha2": "DK",
    "alpha3": "DNK",
    "code": "208",
    "name": "Denmark",
    "emoji": "🇩🇰",
    "unicode": "U+1F1E9 U+1F1F0",
    "dialCode": "+45",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg"
  },
  {
    "alpha2": "EE",
    "alpha3": "EST",
    "code": "233",
    "name": "Estonia",
    "emoji": "🇪🇪",
    "unicode": "U+1F1EA U+1F1EA",
    "dialCode": "+372",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg"
  },
  {
    "alpha2": "FO",
    "alpha3": "FRO",
    "code": "234",
    "name": "Faroe Islands",
    "emoji": "🇫🇴",
    "unicode": "U+1F1EB U+1F1F4",
    "dialCode": "+298",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg"
  },
  {
    "alpha2": "FI",
    "alpha3": "FIN",
    "code": "246",
    "name": "Finland",
    "emoji": "🇫🇮",
    "unicode": "U+1F1EB U+1F1EE",
    "dialCode": "+358",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg"
  },
  {
    "alpha2": "FR",
    "alpha3": "FRA",
    "code": "250",
    "name": "France",
    "emoji": "🇫🇷",
    "unicode": "U+1F1EB U+1F1F7",
    "dialCode": "+33",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg"
  },
  {
    "alpha2": "DE",
    "alpha3": "DEU",
    "code": "276",
    "name": "Germany",
    "emoji": "🇩🇪",
    "unicode": "U+1F1E9 U+1F1EA",
    "dialCode": "+49",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg"
  },
  {
    "alpha2": "GI",
    "alpha3": "GIB",
    "code": "292",
    "name": "Gibraltar",
    "emoji": "🇬🇮",
    "unicode": "U+1F1EC U+1F1EE",
    "dialCode": "+350",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg"
  },
  {
    "alpha2": "GR",
    "alpha3": "GRC",
    "code": "300",
    "name": "Greece",
    "emoji": "🇬🇷",
    "unicode": "U+1F1EC U+1F1F7",
    "dialCode": "+30",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg"
  },
  {
    "alpha2": "VA",
    "alpha3": "VAT",
    "code": "336",
    "name": "Holy See (Vatican City State)",
    "emoji": "🇻🇦",
    "unicode": "U+1F1FB U+1F1E6",
    "dialCode": "+379",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg"
  },
  {
    "alpha2": "HU",
    "alpha3": "HUN",
    "code": "348",
    "name": "Hungary",
    "emoji": "🇭🇺",
    "unicode": "U+1F1ED U+1F1FA",
    "dialCode": "+36",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg"
  },
  {
    "alpha2": "IS",
    "alpha3": "ISL",
    "code": "352",
    "name": "Iceland",
    "emoji": "🇮🇸",
    "unicode": "U+1F1EE U+1F1F8",
    "dialCode": "+354",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg"
  },
  {
    "alpha2": "IE",
    "alpha3": "IRL",
    "code": "372",
    "name": "Ireland",
    "emoji": "🇮🇪",
    "unicode": "U+1F1EE U+1F1EA",
    "dialCode": "+353",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg"
  },
  {
    "alpha2": "IL",
    "alpha3": "ISR",
    "code": "376",
    "name": "Israel",
    "emoji": "🇮🇱",
    "unicode": "U+1F1EE U+1F1F1",
    "dialCode": "+972",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg"
  },
  {
    "alpha2": "IT",
    "alpha3": "ITA",
    "code": "380",
    "name": "Italy",
    "emoji": "🇮🇹",
    "unicode": "U+1F1EE U+1F1F9",
    "dialCode": "+39",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg"
  },
  {
    "alpha2": "LV",
    "alpha3": "LVA",
    "code": "428",
    "name": "Latvia",
    "emoji": "🇱🇻",
    "unicode": "U+1F1F1 U+1F1FB",
    "dialCode": "+371",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg"
  },
  {
    "alpha2": "LI",
    "alpha3": "LIE",
    "code": "438",
    "name": "Liechtenstein",
    "emoji": "🇱🇮",
    "unicode": "U+1F1F1 U+1F1EE",
    "dialCode": "+423",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg"
  },
  {
    "alpha2": "LT",
    "alpha3": "LTU",
    "code": "440",
    "name": "Lithuania",
    "emoji": "🇱🇹",
    "unicode": "U+1F1F1 U+1F1F9",
    "dialCode": "+370",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg"
  },
  {
    "alpha2": "LU",
    "alpha3": "LUX",
    "code": "442",
    "name": "Luxembourg",
    "emoji": "🇱🇺",
    "unicode": "U+1F1F1 U+1F1FA",
    "dialCode": "+352",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg"
  },
  {
    "alpha2": "MK",
    "alpha3": "MKD",
    "code": "807",
    "name": "Macedonia, the Former Yugoslav Republic of",
    "emoji": "🇲🇰",
    "unicode": "U+1F1F2 U+1F1F0",
    "dialCode": "+389",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg"
  },
  {
    "alpha2": "MT",
    "alpha3": "MLT",
    "code": "470",
    "name": "Malta",
    "emoji": "🇲🇹",
    "unicode": "U+1F1F2 U+1F1F9",
    "dialCode": "+356",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg"
  },
  {
    "alpha2": "MD",
    "alpha3": "MDA",
    "code": "498",
    "name": "Moldova, Republic of",
    "emoji": "🇲🇩",
    "unicode": "U+1F1F2 U+1F1E9",
    "dialCode": "+373",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg"
  },
  {
    "alpha2": "MC",
    "alpha3": "MCO",
    "code": "492",
    "name": "Monaco",
    "emoji": "🇲🇨",
    "unicode": "U+1F1F2 U+1F1E8",
    "dialCode": "+377",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg"
  },
  {
    "alpha2": "ME",
    "alpha3": "MNE",
    "code": "499",
    "name": "Montenegro",
    "emoji": "🇲🇪",
    "unicode": "U+1F1F2 U+1F1EA",
    "dialCode": "+382",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg"
  },
  {
    "alpha2": "NL",
    "alpha3": "NLD",
    "code": "528",
    "name": "Netherlands",
    "emoji": "🇳🇱",
    "unicode": "U+1F1F3 U+1F1F1",
    "dialCode": "+31",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg"
  },
  {
    "alpha2": "NO",
    "alpha3": "NOR",
    "code": "578",
    "name": "Norway",
    "emoji": "🇳🇴",
    "unicode": "U+1F1F3 U+1F1F4",
    "dialCode": "+47",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg"
  },
  {
    "alpha2": "PL",
    "alpha3": "POL",
    "code": "616",
    "name": "Poland",
    "emoji": "🇵🇱",
    "unicode": "U+1F1F5 U+1F1F1",
    "dialCode": "+48",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg"
  },
  {
    "alpha2": "PT",
    "alpha3": "PRT",
    "code": "620",
    "name": "Portugal",
    "emoji": "🇵🇹",
    "unicode": "U+1F1F5 U+1F1F9",
    "dialCode": "+351",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg"
  },
  {
    "alpha2": "RO",
    "alpha3": "ROU",
    "code": "642",
    "name": "Romania",
    "emoji": "🇷🇴",
    "unicode": "U+1F1F7 U+1F1F4",
    "dialCode": "+40",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg"
  },
  {
    "alpha2": "RU",
    "alpha3": "RUS",
    "code": "643",
    "name": "Russian Federation",
    "emoji": "🇷🇺",
    "unicode": "U+1F1F7 U+1F1FA",
    "dialCode": "+7",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg"
  },
  {
    "alpha2": "SM",
    "alpha3": "SMR",
    "code": "674",
    "name": "San Marino",
    "emoji": "🇸🇲",
    "unicode": "U+1F1F8 U+1F1F2",
    "dialCode": "+378",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg"
  },
  {
    "alpha2": "RS",
    "alpha3": "SRB",
    "code": "688",
    "name": "Serbia",
    "emoji": "🇷🇸",
    "unicode": "U+1F1F7 U+1F1F8",
    "dialCode": "+381",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg"
  },
  {
    "alpha2": "SK",
    "alpha3": "SVK",
    "code": "703",
    "name": "Slovakia",
    "emoji": "🇸🇰",
    "unicode": "U+1F1F8 U+1F1F0",
    "dialCode": "+421",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg"
  },
  {
    "alpha2": "SI",
    "alpha3": "SVN",
    "code": "705",
    "name": "Slovenia",
    "emoji": "🇸🇮",
    "unicode": "U+1F1F8 U+1F1EE",
    "dialCode": "+386",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg"
  },
  {
    "alpha2": "ES",
    "alpha3": "ESP",
    "code": "724",
    "name": "Spain",
    "emoji": "🇪🇸",
    "unicode": "U+1F1EA U+1F1F8",
    "dialCode": "+34",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg"
  },
  {
    "alpha2": "SE",
    "alpha3": "SWE",
    "code": "752",
    "name": "Sweden",
    "emoji": "🇸🇪",
    "unicode": "U+1F1F8 U+1F1EA",
    "dialCode": "+46",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg"
  },
  {
    "alpha2": "CH",
    "alpha3": "CHE",
    "code": "756",
    "name": "Switzerland",
    "emoji": "🇨🇭",
    "unicode": "U+1F1E8 U+1F1ED",
    "dialCode": "+41",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg"
  },
  {
    "alpha2": "TR",
    "alpha3": "TUR",
    "code": "792",
    "name": "Turkey",
    "emoji": "🇹🇷",
    "unicode": "U+1F1F9 U+1F1F7",
    "dialCode": "+90",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg"
  },
  {
    "alpha2": "UA",
    "alpha3": "UKR",
    "code": "804",
    "name": "Ukraine",
    "emoji": "🇺🇦",
    "unicode": "U+1F1FA U+1F1E6",
    "dialCode": "+380",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg"
  },
  {
    "alpha2": "GB",
    "alpha3": "GBR",
    "code": "826",
    "name": "United Kingdom",
    "emoji": "🇬🇧",
    "unicode": "U+1F1EC U+1F1E7",
    "dialCode": "+44",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg"
  },
  {
    "alpha2": "AI",
    "alpha3": "AIA",
    "code": "660",
    "name": "Anguilla",
    "emoji": "🇦🇮",
    "unicode": "U+1F1E6 U+1F1EE",
    "dialCode": "+1 264",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg"
  },
  {
    "alpha2": "AG",
    "alpha3": "ATG",
    "code": "028",
    "name": "Antigua and Barbuda",
    "emoji": "🇦🇬",
    "unicode": "U+1F1E6 U+1F1EC",
    "dialCode": "+1268",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg"
  },
  {
    "alpha2": "AW",
    "alpha3": "ABW",
    "code": "533",
    "name": "Aruba",
    "emoji": "🇦🇼",
    "unicode": "U+1F1E6 U+1F1FC",
    "dialCode": "+297",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg"
  },
  {
    "alpha2": "BS",
    "alpha3": "BHS",
    "code": "044",
    "name": "Bahamas",
    "emoji": "🇧🇸",
    "unicode": "U+1F1E7 U+1F1F8",
    "dialCode": "+1 242",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg"
  },
  {
    "alpha2": "BB",
    "alpha3": "BRB",
    "code": "052",
    "name": "Barbados",
    "emoji": "🇧🇧",
    "unicode": "U+1F1E7 U+1F1E7",
    "dialCode": "+1 246",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg"
  },
  {
    "alpha2": "BZ",
    "alpha3": "BLZ",
    "code": "084",
    "name": "Belize",
    "emoji": "🇧🇿",
    "unicode": "U+1F1E7 U+1F1FF",
    "dialCode": "+501",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg"
  },
  {
    "alpha2": "BM",
    "alpha3": "BMU",
    "code": "060",
    "name": "Bermuda",
    "emoji": "🇧🇲",
    "unicode": "U+1F1E7 U+1F1F2",
    "dialCode": "+1 441",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg"
  },
  {
    "alpha2": "VG",
    "alpha3": "VGB",
    "code": "092",
    "name": "Virgin Islands, British",
    "emoji": "🇻🇬",
    "unicode": "U+1F1FB U+1F1EC",
    "dialCode": "+1 284",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg"
  },
  {
    "alpha2": "CA",
    "alpha3": "CAN",
    "code": "124",
    "name": "Canada",
    "emoji": "🇨🇦",
    "unicode": "U+1F1E8 U+1F1E6",
    "dialCode": "+1",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg"
  },
  {
    "alpha2": "KY",
    "alpha3": "CYM",
    "code": "136",
    "name": "Cayman Islands",
    "emoji": "🇰🇾",
    "unicode": "U+1F1F0 U+1F1FE",
    "dialCode": "+ 345",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg"
  },
  {
    "alpha2": "CR",
    "alpha3": "CRI",
    "code": "188",
    "name": "Costa Rica",
    "emoji": "🇨🇷",
    "unicode": "U+1F1E8 U+1F1F7",
    "dialCode": "+506",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg"
  },
  {
    "alpha2": "CU",
    "alpha3": "CUB",
    "code": "192",
    "name": "Cuba",
    "emoji": "🇨🇺",
    "unicode": "U+1F1E8 U+1F1FA",
    "dialCode": "+53",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg"
  },
  {
    "alpha2": "DM",
    "alpha3": "DMA",
    "code": "212",
    "name": "Dominica",
    "emoji": "🇩🇲",
    "unicode": "U+1F1E9 U+1F1F2",
    "dialCode": "+1 767",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg"
  },
  {
    "alpha2": "DO",
    "alpha3": "DOM",
    "code": "214",
    "name": "Dominican Republic",
    "emoji": "🇩🇴",
    "unicode": "U+1F1E9 U+1F1F4",
    "dialCode": "+1 849",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg"
  },
  {
    "alpha2": "SV",
    "alpha3": "SLV",
    "code": "222",
    "name": "El Salvador",
    "emoji": "🇸🇻",
    "unicode": "U+1F1F8 U+1F1FB",
    "dialCode": "+503",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg"
  },
  {
    "alpha2": "GL",
    "alpha3": "GRL",
    "code": "304",
    "name": "Greenland",
    "emoji": "🇬🇱",
    "unicode": "U+1F1EC U+1F1F1",
    "dialCode": "+299",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg"
  },
  {
    "alpha2": "GD",
    "alpha3": "GRD",
    "code": "308",
    "name": "Grenada",
    "emoji": "🇬🇩",
    "unicode": "U+1F1EC U+1F1E9",
    "dialCode": "+1 473",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg"
  },
  {
    "alpha2": "GP",
    "alpha3": "GLP",
    "code": "312",
    "name": "Guadeloupe",
    "emoji": "🇬🇵",
    "unicode": "U+1F1EC U+1F1F5",
    "dialCode": "+590",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg"
  },
  {
    "alpha2": "GT",
    "alpha3": "GTM",
    "code": "320",
    "name": "Guatemala",
    "emoji": "🇬🇹",
    "unicode": "U+1F1EC U+1F1F9",
    "dialCode": "+502",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg"
  },
  {
    "alpha2": "HT",
    "alpha3": "HTI",
    "code": "332",
    "name": "Haiti",
    "emoji": "🇭🇹",
    "unicode": "U+1F1ED U+1F1F9",
    "dialCode": "+509",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg"
  },
  {
    "alpha2": "HN",
    "alpha3": "HND",
    "code": "340",
    "name": "Honduras",
    "emoji": "🇭🇳",
    "unicode": "U+1F1ED U+1F1F3",
    "dialCode": "+504",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg"
  },
  {
    "alpha2": "JM",
    "alpha3": "JAM",
    "code": "388",
    "name": "Jamaica",
    "emoji": "🇯🇲",
    "unicode": "U+1F1EF U+1F1F2",
    "dialCode": "+1 876",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg"
  },
  {
    "alpha2": "MQ",
    "alpha3": "MTQ",
    "code": "474",
    "name": "Martinique",
    "emoji": "🇲🇶",
    "unicode": "U+1F1F2 U+1F1F6",
    "dialCode": "+596",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg"
  },
  {
    "alpha2": "MX",
    "alpha3": "MEX",
    "code": "484",
    "name": "Mexico",
    "emoji": "🇲🇽",
    "unicode": "U+1F1F2 U+1F1FD",
    "dialCode": "+52",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg"
  },
  {
    "alpha2": "NI",
    "alpha3": "NIC",
    "code": "558",
    "name": "Nicaragua",
    "emoji": "🇳🇮",
    "unicode": "U+1F1F3 U+1F1EE",
    "dialCode": "+505",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg"
  },
  {
    "alpha2": "PA",
    "alpha3": "PAN",
    "code": "591",
    "name": "Panama",
    "emoji": "🇵🇦",
    "unicode": "U+1F1F5 U+1F1E6",
    "dialCode": "+507",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg"
  },
  {
    "alpha2": "PR",
    "alpha3": "PRI",
    "code": "630",
    "name": "Puerto Rico",
    "emoji": "🇵🇷",
    "unicode": "U+1F1F5 U+1F1F7",
    "dialCode": "+1 939",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg"
  },
  {
    "alpha2": "KN",
    "alpha3": "KNA",
    "code": "659",
    "name": "Saint Kitts and Nevis",
    "emoji": "🇰🇳",
    "unicode": "U+1F1F0 U+1F1F3",
    "dialCode": "+1 869",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg"
  },
  {
    "alpha2": "LC",
    "alpha3": "LCA",
    "code": "662",
    "name": "Saint Lucia",
    "emoji": "🇱🇨",
    "unicode": "U+1F1F1 U+1F1E8",
    "dialCode": "+1 758",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg"
  },
  {
    "alpha2": "PM",
    "alpha3": "SPM",
    "code": "666",
    "name": "Saint Pierre and Miquelon",
    "emoji": "🇵🇲",
    "unicode": "U+1F1F5 U+1F1F2",
    "dialCode": "+508",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg"
  },
  {
    "alpha2": "VC",
    "alpha3": "VCT",
    "code": "670",
    "name": "Saint Vincent and the Grenadines",
    "emoji": "🇻🇨",
    "unicode": "U+1F1FB U+1F1E8",
    "dialCode": "+1 784",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg"
  },
  {
    "alpha2": "BL",
    "alpha3": "BLM",
    "code": "652",
    "name": "Saint Barthélemy",
    "emoji": "🇧🇱",
    "unicode": "U+1F1E7 U+1F1F1",
    "dialCode": "+590",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg"
  },
  {
    "alpha2": "TT",
    "alpha3": "TTO",
    "code": "780",
    "name": "Trinidad and Tobago",
    "emoji": "🇹🇹",
    "unicode": "U+1F1F9 U+1F1F9",
    "dialCode": "+1 868",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg"
  },
  {
    "alpha2": "TC",
    "alpha3": "TCA",
    "code": "796",
    "name": "Turks and Caicos Islands",
    "emoji": "🇹🇨",
    "unicode": "U+1F1F9 U+1F1E8",
    "dialCode": "+1 649",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg"
  },
  {
    "alpha2": "US",
    "alpha3": "USA",
    "code": "840",
    "name": "United States of America",
    "emoji": "🇺🇸",
    "unicode": "U+1F1FA U+1F1F8",
    "dialCode": "+1",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg"
  },
  {
    "alpha2": "VI",
    "alpha3": "VIR",
    "code": "850",
    "name": "Virgin Islands, U.S.",
    "emoji": "🇻🇮",
    "unicode": "U+1F1FB U+1F1EE",
    "dialCode": "+1 340",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg"
  },
  {
    "alpha2": "AS",
    "alpha3": "ASM",
    "code": "016",
    "name": "American Samoa",
    "emoji": "🇦🇸",
    "unicode": "U+1F1E6 U+1F1F8",
    "dialCode": "+1 684",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg"
  },
  {
    "alpha2": "AU",
    "alpha3": "AUS",
    "code": "036",
    "name": "Australia",
    "emoji": "🇦🇺",
    "unicode": "U+1F1E6 U+1F1FA",
    "dialCode": "+61",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg"
  },
  {
    "alpha2": "CK",
    "alpha3": "COK",
    "code": "184",
    "name": "Cook Islands",
    "emoji": "🇨🇰",
    "unicode": "U+1F1E8 U+1F1F0",
    "dialCode": "+682",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg"
  },
  {
    "alpha2": "FJ",
    "alpha3": "FJI",
    "code": "242",
    "name": "Fiji",
    "emoji": "🇫🇯",
    "unicode": "U+1F1EB U+1F1EF",
    "dialCode": "+679",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg"
  },
  {
    "alpha2": "PF",
    "alpha3": "PYF",
    "code": "258",
    "name": "French Polynesia",
    "emoji": "🇵🇫",
    "unicode": "U+1F1F5 U+1F1EB",
    "dialCode": "+689",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg"
  },
  {
    "alpha2": "GU",
    "alpha3": "GUM",
    "code": "316",
    "name": "Guam",
    "emoji": "🇬🇺",
    "unicode": "U+1F1EC U+1F1FA",
    "dialCode": "+1 671",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg"
  },
  {
    "alpha2": "KI",
    "alpha3": "KIR",
    "code": "296",
    "name": "Kiribati",
    "emoji": "🇰🇮",
    "unicode": "U+1F1F0 U+1F1EE",
    "dialCode": "+686",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg"
  },
  {
    "alpha2": "MH",
    "alpha3": "MHL",
    "code": "584",
    "name": "Marshall Islands",
    "emoji": "🇲🇭",
    "unicode": "U+1F1F2 U+1F1ED",
    "dialCode": "+692",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg"
  },
  {
    "alpha2": "FM",
    "alpha3": "FSM",
    "code": "583",
    "name": "Micronesia, Federated States of",
    "emoji": "🇫🇲",
    "unicode": "U+1F1EB U+1F1F2",
    "dialCode": "+691",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg"
  },
  {
    "alpha2": "NR",
    "alpha3": "NRU",
    "code": "520",
    "name": "Nauru",
    "emoji": "🇳🇷",
    "unicode": "U+1F1F3 U+1F1F7",
    "dialCode": "+674",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg"
  },
  {
    "alpha2": "NC",
    "alpha3": "NCL",
    "code": "540",
    "name": "New Caledonia",
    "emoji": "🇳🇨",
    "unicode": "U+1F1F3 U+1F1E8",
    "dialCode": "+687",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg"
  },
  {
    "alpha2": "NZ",
    "alpha3": "NZL",
    "code": "554",
    "name": "New Zealand",
    "emoji": "🇳🇿",
    "unicode": "U+1F1F3 U+1F1FF",
    "dialCode": "+64",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg"
  },
  {
    "alpha2": "NU",
    "alpha3": "NIU",
    "code": "570",
    "name": "Niue",
    "emoji": "🇳🇺",
    "unicode": "U+1F1F3 U+1F1FA",
    "dialCode": "+683",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg"
  },
  {
    "alpha2": "NF",
    "alpha3": "NFK",
    "code": "574",
    "name": "Norfolk Island",
    "emoji": "🇳🇫",
    "unicode": "U+1F1F3 U+1F1EB",
    "dialCode": "+672",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg"
  },
  {
    "alpha2": "MP",
    "alpha3": "MNP",
    "code": "580",
    "name": "Northern Mariana Islands",
    "emoji": "🇲🇵",
    "unicode": "U+1F1F2 U+1F1F5",
    "dialCode": "+1 670",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg"
  },
  {
    "alpha2": "PW",
    "alpha3": "PLW",
    "code": "585",
    "name": "Palau",
    "emoji": "🇵🇼",
    "unicode": "U+1F1F5 U+1F1FC",
    "dialCode": "+680",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg"
  },
  {
    "alpha2": "PG",
    "alpha3": "PNG",
    "code": "598",
    "name": "Papua New Guinea",
    "emoji": "🇵🇬",
    "unicode": "U+1F1F5 U+1F1EC",
    "dialCode": "+675",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg"
  },
  {
    "alpha2": "PN",
    "alpha3": "PCN",
    "code": "612",
    "name": "Pitcairn",
    "emoji": "🇵🇳",
    "unicode": "U+1F1F5 U+1F1F3",
    "dialCode": "+872",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg"
  },
  {
    "alpha2": "WS",
    "alpha3": "WSM",
    "code": "882",
    "name": "Samoa",
    "emoji": "🇼🇸",
    "unicode": "U+1F1FC U+1F1F8",
    "dialCode": "+685",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg"
  },
  {
    "alpha2": "SB",
    "alpha3": "SLB",
    "code": "090",
    "name": "Solomon Islands",
    "emoji": "🇸🇧",
    "unicode": "U+1F1F8 U+1F1E7",
    "dialCode": "+677",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg"
  },
  {
    "alpha2": "TL",
    "alpha3": "TLS",
    "code": "626",
    "name": "Timor-Leste",
    "emoji": "🇹🇱",
    "unicode": "U+1F1F9 U+1F1F1",
    "dialCode": "+670",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg"
  },
  {
    "alpha2": "TO",
    "alpha3": "TON",
    "code": "776",
    "name": "Tonga",
    "emoji": "🇹🇴",
    "unicode": "U+1F1F9 U+1F1F4",
    "dialCode": "+676",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg"
  },
  {
    "alpha2": "TV",
    "alpha3": "TUV",
    "code": "798",
    "name": "Tuvalu",
    "emoji": "🇹🇻",
    "unicode": "U+1F1F9 U+1F1FB",
    "dialCode": "+688",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg"
  },
  {
    "alpha2": "VU",
    "alpha3": "VUT",
    "code": "548",
    "name": "Vanuatu",
    "emoji": "🇻🇺",
    "unicode": "U+1F1FB U+1F1FA",
    "dialCode": "+678",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg"
  },
  {
    "alpha2": "AR",
    "alpha3": "ARG",
    "code": "032",
    "name": "Argentina",
    "emoji": "🇦🇷",
    "unicode": "U+1F1E6 U+1F1F7",
    "dialCode": "+54",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg"
  },
  {
    "alpha2": "BO",
    "alpha3": "BOL",
    "code": "068",
    "name": "Bolivia",
    "emoji": "🇧🇴",
    "unicode": "U+1F1E7 U+1F1F4",
    "dialCode": "+591",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg"
  },
  {
    "alpha2": "BR",
    "alpha3": "BRA",
    "code": "076",
    "name": "Brazil",
    "emoji": "🇧🇷",
    "unicode": "U+1F1E7 U+1F1F7",
    "dialCode": "+55",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg"
  },
  {
    "alpha2": "CL",
    "alpha3": "CHL",
    "code": "152",
    "name": "Chile",
    "emoji": "🇨🇱",
    "unicode": "U+1F1E8 U+1F1F1",
    "dialCode": "+56",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg"
  },
  {
    "alpha2": "CO",
    "alpha3": "COL",
    "code": "170",
    "name": "Colombia",
    "emoji": "🇨🇴",
    "unicode": "U+1F1E8 U+1F1F4",
    "dialCode": "+57",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg"
  },
  {
    "alpha2": "EC",
    "alpha3": "ECU",
    "code": "218",
    "name": "Ecuador",
    "emoji": "🇪🇨",
    "unicode": "U+1F1EA U+1F1E8",
    "dialCode": "+593",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg"
  },
  {
    "alpha2": "FK",
    "alpha3": "FLK",
    "code": "238",
    "name": "Falkland Islands (Malvinas)",
    "emoji": "🇫🇰",
    "unicode": "U+1F1EB U+1F1F0",
    "dialCode": "+500",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg"
  },
  {
    "alpha2": "GF",
    "alpha3": "GUF",
    "code": "254",
    "name": "French Guiana",
    "emoji": "🇬🇫",
    "unicode": "U+1F1EC U+1F1EB",
    "dialCode": "+594",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg"
  },
  {
    "alpha2": "GY",
    "alpha3": "GUY",
    "code": "328",
    "name": "Guyana",
    "emoji": "🇬🇾",
    "unicode": "U+1F1EC U+1F1FE",
    "dialCode": "+595",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg"
  },
  {
    "alpha2": "PY",
    "alpha3": "PRY",
    "code": "600",
    "name": "Paraguay",
    "emoji": "🇵🇾",
    "unicode": "U+1F1F5 U+1F1FE",
    "dialCode": "+595",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg"
  },
  {
    "alpha2": "PE",
    "alpha3": "PER",
    "code": "604",
    "name": "Peru",
    "emoji": "🇵🇪",
    "unicode": "U+1F1F5 U+1F1EA",
    "dialCode": "+51",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg"
  },
  {
    "alpha2": "SR",
    "alpha3": "SUR",
    "code": "740",
    "name": "Suriname",
    "emoji": "🇸🇷",
    "unicode": "U+1F1F8 U+1F1F7",
    "dialCode": "+597",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg"
  },
  {
    "alpha2": "UY",
    "alpha3": "URY",
    "code": "858",
    "name": "Uruguay",
    "emoji": "🇺🇾",
    "unicode": "U+1F1FA U+1F1FE",
    "dialCode": "+598",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg"
  },
  {
    "alpha2": "VE",
    "alpha3": "VEN",
    "code": "862",
    "name": "Venezuela",
    "emoji": "🇻🇪",
    "unicode": "U+1F1FB U+1F1EA",
    "dialCode": "+58",
    "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg"
  }
]
